import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
`;

export const AreaAbsoluteInfoQuote = styled.div`
  position: absolute;
  right: 14px;
  top: 10px;
  transform: translateY(-50%);
`;

